<template>
  <div class="quote-breakdown-container">
    <div class="quote-breakdown" v-show="activeKey === key" :class="`quote-breakdown--${key}`" v-for="(paymentBreakdown, key) in breakdownsByInterval" :key="key">
      <div class="quote-breakdown__graph-title-row"><span class="quote-breakdown__graph-title-row__title">Cost breakdown <span
          class="bulma-modal-trigger" @click.stop="toggleModal()"><img src="/assets/images/2021/info_icon.svg" class="more-info-icon"
                                                                        alt="More Information"></span></span>
        <div class="buttons has-addons quote-breakdown__graph-title-row__tab-buttons" v-if="Object.keys(breakdownsByInterval).length > 1">
          <a class="button is-tiny is-uppercase"  :class="{'is-grey': activeKey === Object.keys(breakdownsByInterval)[0]}" @click.stop="setActiveKey(Object.keys(breakdownsByInterval)[0])">{{ Object.keys(breakdownsByInterval)[0] }}</a>
          <a class="button is-tiny is-uppercase" :class="{'is-grey': activeKey === Object.keys(breakdownsByInterval)[1]}" @click.stop="setActiveKey(Object.keys(breakdownsByInterval)[1])">{{ Object.keys(breakdownsByInterval)[1]}}</a>
        </div>
      </div>
      <div class="quote-breakdown__graph" v-if="paymentBreakdown.total_cost_inc_gst !== 0">
        <a class="quote-breakdown__percent quote-breakdown__percent--premium"
           v-bind:style="barWidthCalculated(paymentBreakdown.insurer_premium, paymentBreakdown.total_cost_inc_gst)"
           v-tooltip="{ content: `Insurer premium ${$options.filters.toCurrency(paymentBreakdown.insurer_premium,2)}`, trigger: 'hover touch click focus', delay: delayValue }">
              <span class="quote-breakdown__percent-line"></span>
              <span class="quote-breakdown__percent-amount">
                <span class="quote-breakdown__value is-hidden-mobile">{{paymentBreakdown.insurer_premium | toCurrency}}</span>
              </span>
        </a>
        <a class="quote-breakdown__percent quote-breakdown__percent--fee"
           v-bind:style="barWidthCalculated(paymentBreakdown.fee, paymentBreakdown.total_cost_inc_gst)"
           v-tooltip="{ content: `Transaction & Platform Fee ${$options.filters.toCurrency(paymentBreakdown.fee,2)}`, trigger: 'hover touch click focus', delay: delayValue }">
            <span class="quote-breakdown__percent-line"></span>
            <span class="quote-breakdown__percent-amount">
              <span class="quote-breakdown__value is-hidden-mobile">{{paymentBreakdown.fee | toCurrency}}</span>
            </span>
        </a>
        <a class="quote-breakdown__percent quote-breakdown__percent--levies"
           v-bind:style="barWidthCalculated(paymentBreakdown.total_levies, paymentBreakdown.total_cost_inc_gst)"
           v-tooltip="{ content: `Govt Levies ${$options.filters.toCurrency(paymentBreakdown.total_levies,2)}`, trigger: 'hover touch click focus', delay: delayValue }">
          <span class="quote-breakdown__percent-line"></span>
          <span class="quote-breakdown__percent-amount">
            <span class="quote-breakdown__value is-hidden-mobile">{{paymentBreakdown.total_levies | toCurrency}}</span>
          </span>
        </a>
        <a class="quote-breakdown__percent quote-breakdown__percent--gst"
           v-bind:style="barWidthCalculated(paymentBreakdown.total_gst, paymentBreakdown.total_cost_inc_gst)"
           v-tooltip="{ content: `GST ${$options.filters.toCurrency(paymentBreakdown.total_gst,2)}`, trigger: 'hover touch click focus', delay: delayValue }">
          <span class="quote-breakdown__percent-line"></span>
          <span class="quote-breakdown__percent-amount">
            <span class="quote-breakdown__value is-hidden-mobile">{{paymentBreakdown.total_gst | toCurrency}}</span>
          </span>
        </a>
      </div>
      <div class="quote-breakdown__key_group">
        <span v-if="notZero(paymentBreakdown.insurer_premium)" class="quote-breakdown__key quote-breakdown__key--premium">Insurer premium</span>
        <span v-if="notZero(paymentBreakdown.fee)" class="quote-breakdown__key quote-breakdown__key--fee">Fee</span>
        <span v-if="notZero(paymentBreakdown.total_levies)" class="quote-breakdown__key quote-breakdown__key--levies">Govt Levies</span>
        <span v-if="notZero(paymentBreakdown.total_gst)" class="quote-breakdown__key  quote-breakdown__key--gst">GST</span>
      </div>
      <span class="quote-breakdown__disclosure_link"><a href="/disclosure-statement/" target="_blank">View our disclosure statement</a></span>
    </div>

    <modal
        v-if="modalOpen"
        :class="{ 'is-active': modalOpen }"
        v-on:childToParent="toggleModal"
        title="Cost breakdown"
        footer=""
    >
      <div class="content">
          <p>The cost breakdown shows the various components that make up the total cost of this insurance, relative to one another.  Hover over each one to see the actual amount.</p>
          <p>The Insurer premium includes commission which Initio earns as part of this transaction.</p>
          <p>The intermediary revenue is further explained in our <a href="/disclosure-statement/" target="_blank">disclosure statement</a>.</p>
      </div>
    </modal>

  </div>
</template>

<script>

/*
 Note: expect breakDownsByInterval to be a single or two values in an object such as:
{
  "yearly": {
    "insurer_premium": 513.15,
    "total_gst": 78.24,
    "total_levies": 8.45,
    "total_cost_inc_gst": 599.84
  },
  "monthly": {
    "insurer_premium": 47.91,
    "total_gst": 7.29,
    "total_levies": 8.45,
    "total_cost_inc_gst": 55.9
  }
}

 */

export default {
  props: {
    breakdownsByInterval: {
      type: Object,
      required: true
    },
  },
  mounted () {

  },
  components: {

  },
  methods: {
    setActiveKey: function(key){
      // console.log('setActiveKey',key);
      this.activeKey = key;
    },
    barWidthCalculated: function(value, total){
      return { width: Math.round(((value / total) * 100)) + '%',  }
    },
    notZero(value){
      return value !== 0;
    },
    toggleModal: function () {
      this.modalOpen = ! this.modalOpen;
    },
  },
  watch: {
    // Watch the prop data, when the data turns up, set the default value
    breakdownsByInterval (newValue,oldValue) {
      // console.log("newValue/OldValue", newValue, oldValue, this.activeKey);
      if ( newValue !== oldValue && this.activeKey === undefined ) {
        // Attempt to default it to Annual ( second in array ) if it exists
        if(Object.keys(this.breakdownsByInterval).length > 1 ){
            this.activeKey = Object.keys(this.breakdownsByInterval)[1];
        } else {
            // Fallback to the first item if we only have one 
            this.activeKey = Object.keys(this.breakdownsByInterval)[0];
        }
      }
    }
  },
  computed: {
    delayValue(){
      return { show: 500, hide: 100 }
    }
  },
  data () {
    return {
      activeKey: this.breakdownsByInterval ? Object.keys(this.breakdownsByInterval)[0] : null,
      modalOpen: false,
    }
  },
}

</script>
<style  scoped lang="scss">

.more-info-icon {
  cursor: pointer;
}
.quote-breakdown-container {
  margin-bottom: 20px;
}
.quote-breakdown {
  margin-top:5px;
  color: #86847d;
}

.quote-breakdown__title {
  font-size:13px;
  display: block;
  margin-bottom: 5px;
}

.quote-breakdown__item {
  display: block;
  font-size:14px;
  margin-bottom:3px;
}

.quote-breakdown__item__title {
  width: 210px;
  display: inline-block;
}

.quote-breakdown .quote-breakdown__graph {
  display: table;
  width: 100%;
  border-radius: 5px;
  overflow: hidden;
}


.quote-breakdown__graph-title-row {
  display: flex;
  margin-bottom: 20px;
}

.quote-breakdown__graph-title-row__tab-buttons {
  display: inline-block;
  margin-left: auto;
}

.quote-breakdown__graph-title-row__title {
  font-size: 14px;
  line-height: 8px;
  color: #303030;
  font-weight: bold;
  display: flex;
  align-items: center;
}


.quote-breakdown .quote-breakdown__percent {
  display: table-cell;
  font-size: 12px;
  cursor: default;
  vertical-align: top;
  /*pointer-events: none;*/
}

.quote-breakdown .quote-breakdown__percent-line {
  display: block;
  height: 12px;
  margin-bottom: 13px;
}

.quote-breakdown  .quote-breakdown__value {
  color: #4E4A49;
  /*display: block;*/
  display: none;
}

.quote-breakdown  .quote-breakdown__title {
  display: block;
}

.quote-breakdown  .quote-breakdown__disclosure_link {
  display: block;
  font-size: 12px;
  margin-top: 10px;
}
.quote-breakdown  .quote-breakdown__disclosure_link a {
  text-decoration: underline;
}

$premium_colour: #82B541;
$levies_colour: #7741B5;
$gst_colour: #41ACB5;
$fee_colour: #70983C;

.quote-breakdown .quote-breakdown__percent--premium .quote-breakdown__percent-line {
  background-color: $premium_colour;
  border-top-left-radius: 12px;
  border-bottom-left-radius: 12px;
}
.quote-breakdown .quote-breakdown__percent--premium .quote-breakdown__percent-title,
.quote-breakdown .quote-breakdown__key.quote-breakdown__key--premium {
  color: $premium_colour;
}
.quote-breakdown .quote-breakdown__key--premium:before {
  background-color: $premium_colour;
}


.quote-breakdown .quote-breakdown__percent--fee .quote-breakdown__percent-line {
    background-color: $fee_colour;
}
.quote-breakdown .quote-breakdown__percent--fee .quote-breakdown__percent-title,
.quote-breakdown .quote-breakdown__key.quote-breakdown__key--fee {
    color: $fee_colour;
}
.quote-breakdown .quote-breakdown__key--fee:before {
    background-color: $fee_colour;
}


.quote-breakdown .quote-breakdown__percent--levies .quote-breakdown__percent-line {
  background-color: $levies_colour;
}
.quote-breakdown .quote-breakdown__percent--levies .quote-breakdown__percent-title,
.quote-breakdown .quote-breakdown__key.quote-breakdown__key--levies {
  color: $levies_colour;
}
.quote-breakdown .quote-breakdown__key--levies:before {
  background-color: $levies_colour;
}

.quote-breakdown .quote-breakdown__percent--gst .quote-breakdown__percent-line {
  background-color: $gst_colour;
  border-top-right-radius: 12px;
  border-bottom-right-radius: 12px;
}
.quote-breakdown .quote-breakdown__percent--gst .quote-breakdown__percent-title,
.quote-breakdown .quote-breakdown__key.quote-breakdown__key--gst {
  color: $gst_colour;
}

.quote-breakdown .quote-breakdown__key--gst:before {
  background-color: $gst_colour;
}

.quote-breakdown .quote-breakdown__key {
  margin-right: 20px;
  &:before {
    content: '';
    display: inline-block;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    margin-right: 5px;
  }
}

</style>
